const changeNameStr = {
  toastr: 'Nome alterado',
  toastr1: 'nome alterado com sucesso'
};

export default changeNameStr;
